import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'
import type AssignmentsProductManagePastRoute from 'teacher-ui-client/assignments/product/manage/past/route'

export default class AssignmentsProductManagePastController extends Controller<
  ModelFor<AssignmentsProductManagePastRoute>
> {
  @tracked pageNumber = 1

  @tracked perPage = 20

  @tracked sortColumn = 'end_at'

  @tracked sortDirection = 'desc'

  queryParams = ['pageNumber', 'perPage', 'sortColumn', 'sortDirection', 'selectedAssignmentId']

  @tracked selectedAssignmentId?: string

  get totalResults() {
    return this.model.totalAssignments ?? 0
  }

  get totalNumOfPages() {
    return Math.ceil(this.totalResults / this.perPage)
  }

  get assignments() {
    return this.model.assignments
  }

  get selectedAssignment() {
    return this.assignments.find((assignment) => this.selectedAssignmentId === assignment.id)
  }

  @action
  showAssignment(id: string) {
    this.selectedAssignmentId = id
  }

  @action
  closeAssignment() {
    this.selectedAssignmentId = undefined
  }

  @action
  sortColumnAction(column: string, direction: string) {
    this.sortDirection = direction
    this.sortColumn = column
  }
}
